import React from "react";
import Joi from "joi-browser";
import {Form} from "./form.jsx";
import { ConfigContext } from "./../../context/ConfigContext";
import axios from "axios";


class UploadDict extends Form {
	
  static contextType = ConfigContext; 
	
  state = {
    selectedFileD2: null,
    selectedFileD3: null,
    successMessageD2: "",
    successMessageD3: "",
  };

  componentDidMount() {
    console.log("upload Dict Component did mount!");
  }

  componentWillUnmount() {
    console.log("upload Dict Component UnMount!");
  }

  handleFileChange = (event) => {
    const { id, files } = event.target;
    if (id === "file-input-D2") {
      this.setState({ selectedFileD2: files[0] });
    } else if (id === "file-input-D3") {
      this.setState({ selectedFileD3: files[0] });
    }
  };

  handleStartRun = async (dictType) => {
    await this.handleUploadFile(dictType);
  };

  handleUploadFile = async (dictType) => {
    let selectedFile;
    if (dictType === "D2") {
      selectedFile = this.state.selectedFileD2;
    } else if (dictType === "D3") {
      selectedFile = this.state.selectedFileD3;
    }

    const formData = new FormData();
    if (!selectedFile) return;
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        `${this.context.generalEndPoint}/uploadDict`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          params: {
            dictType: dictType,
          },
        }
      );

      console.log(" : UploadDict : ", response);

      const currentDateTime = new Date().toLocaleString();
      if (dictType === "D2") {
        this.setState({
          successMessageD2: `File D2 uploaded successfully at ${currentDateTime}`,
        });
      } else if (dictType === "D3") {
        this.setState({
          successMessageD3: `File D3 uploaded successfully at ${currentDateTime}`,
        });
      }
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };

  render() {
    const {
      selectedFileD2,
      selectedFileD3,
      successMessageD2,
      successMessageD3,
    } = this.state;

    let sidebarClicked = sessionStorage.getItem("CurrentMouseLocation");
    let workAreaClassMame = "workAreaPageUpload";
    if (sidebarClicked !== null) {
      workAreaClassMame = "workAreaPageAnimationUpload";
    } else {
      workAreaClassMame = "workAreaPageUpload";
    }

    return (
      <div id="wellcomeDiv">
        <div className={workAreaClassMame}>
          <form onSubmit={this.handleSubmit}>
            <div id="TamarTitleDiv">
              <p className="Tamar_Title">טעינת מילוני בדיקות</p>
            </div>

            <div id="TamarTitleDiv">
              <p className="Title_uploadDict">
                <span>מילון בדיקות המרה</span>
              </p>
            </div>

            <div id="TamarLoad">
              <div className="column-right">
                <div className="row">
                  <input
                    className=""
                    type="file"
                    onChange={this.handleFileChange}
                    id="file-input-D2"
                  />
                  <button
                    type="button"
                    className="browseButton"
                    onClick={() =>
                      document.getElementById("file-input-D2").click()
                    }>
                    {" "}
                    ...{" "}
                  </button>
                  {selectedFileD2 && <div></div>}
                  <button
                    type="button"
                    className="start-button"
                    onClick={() => this.handleStartRun("D2")}>
                    {" "}
                    התחלת טעינה
                  </button>
                </div>
                {/* {successMessageD2 && (
                  <div className="bordered-box">
                    <p>{successMessageD2}</p>
                  </div>
                )} */}
              </div>
            </div>

            <div className="separator"></div>

            <div id="TamarTitleDiv">
              <p className="Title_uploadDict">
                <span>מילון בדיקות איכות והשוואה </span>
              </p>
            </div>
            <div id="TamarLoad">
              <div className="column-right">
                <div className="row">
                  <input
                    className=""
                    type="file"
                    onChange={this.handleFileChange}
                    id="file-input-D3"
                  />
                  <button
                    type="button"
                    className="browseButton"
                    onClick={() =>
                      document.getElementById("file-input-D3").click()
                    }>
                    {" "}
                    ...{" "}
                  </button>
                  {selectedFileD3 && <div></div>}
                  <button
                    type="button"
                    className="start-button"
                    onClick={() => this.handleStartRun("D3")}>
                    {" "}
                    התחלת טעינה
                  </button>
                </div>
                {/* {successMessageD3 && (
                  <div className="row">
                    <div className="success-message">
                      {successMessageD3}
                    </div>
                  </div>
                )} */}
              </div>
            </div>

            <div className="separator"></div>

            <div className="bordered-box">
              <p>{successMessageD2}</p>
              <p>{successMessageD3}</p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default UploadDict;
